
import { orderClose, orderRefuseAcceptComplete } from '@/api/order';
import { isEmpty } from '@/utils';
import { makeKey } from '@/utils/qiniu';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import DialogImgLarge from '@/components/ImgLarge/index.vue';

@Component({
  name: 'faultDialog',
  components: {
    DialogImgLarge }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  confirmDialogVisible!: boolean;

   @Prop({
     type: String,
     default: ''
   })
  dialogTitle!: String;
  @Prop({
    type: String,
    default: ''
  })
  operationType!: any;
  @Prop({
    type: Object,
    default: () => {}
  })
  qiuniuToken!: any;
  @Prop({
    type: Object,
    default: () => {}
  })
  operationData!: any;

  // 七牛
  private action = 'https://up-z1.qiniup.com';
  private qiuniuform={}
  private qiniuPicList:any=[]

  private closeForm:any={}
  private operations: Record<string, Function> = {
    // 'finish': orderFinish,
    // 'remind': orderRemind,
    'close': orderClose,
    'refuse': orderRefuseAcceptComplete
  };

  created() {
  }

  // 骑牛
  private uploadSuccess(res: any) {
    this.qiniuPicList.push(res.key);
  }
  private beforeUpload(file:any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then(res => {
      let k = makeKey(this.qiuniuToken.prekey);
      this.qiuniuform = {
        key: k,
        token: this.qiuniuToken.uptoken,
        domain: this.qiuniuToken.domain
      };
    });
  }
  close() {
    this.$emit('close', false);
  }
  handleDialogConfirm() {
    const types :any = ['refuse', 'close'];
    if (!types.includes(this.operationType)) {
      this.$emit('close', false);
      return;
    }
    if (!this.closeForm.name || isEmpty(this.closeForm.name.trim())) {
      this.showErrorMsg('请填写备注');
      return;
    }
    const params: any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      order_id: this.operationData.order.id,
      order_service_id: this.operationData.order_service.id
    };
    if (this.closeForm.name) {
      params.remark = this.closeForm.name;
    }
    if (this.qiniuPicList && this.qiniuPicList.length > 0) {
      params.images = this.qiniuPicList.join(',');
    }
    this.operations[this.operationType](params).then((res:any) => {
      this.showSuccessMsg(res.msg);
      setTimeout(() => {
        this.$emit('handleDialogConfirm');
      }, 500);
    }).catch((err:any) => {
      this.showErrorMsg(err.msg);
    });
  }
  private imgLargeHandle(val: [], index: number) {
    let arr = [];
    for (let i = 0; i < val.length; i++) {
      arr.push(this.qiuniuToken.default_url + val[i]);
    }
    let enlargedData = {
      isShow: true,
      imgList: arr,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private deleteImgHandle(val: number) {
    this.qiniuPicList.splice(val, 1);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
